import { render, staticRenderFns } from "./client-type-list.vue?vue&type=template&id=ee56e4b4&"
import script from "./client-type-list.vue?vue&type=script&lang=js&"
export * from "./client-type-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports